export const version = '2.13.0';
//# sourceMappingURL=version.js.map